import { FormattedMessage } from "react-intl";
import { timeZones } from "../../../timeZones";
import { engagementCenter } from "./engagementCenter";

export const notificationDetails = {
  name: (location, tenantName) =>
    location?.pathname.includes(
      engagementCenter.addNotificationPath(tenantName)
    )
      ? "Add New Notification"
      : "Edit Notification",
  heading: (location, tenantName) =>
    location?.pathname.includes(
      engagementCenter.addNotificationPath(tenantName)
    )
      ? "Add Details"
      : "Edit Details",
  path: (location, tenantName, notificationId) =>
    location?.pathname.includes(
      engagementCenter.addNotificationPath(tenantName)
    )
      ? engagementCenter.addNotificationPath(tenantName)
      : engagementCenter.editNotificationPath(tenantName, notificationId),
  navLinks: (navigate, tenantName, location, notificationId) => [
    ...engagementCenter.navLinks(navigate, tenantName),
    {
      key: 3,
      label: notificationDetails.name(location, tenantName),
      path: notificationDetails.path(location, tenantName, notificationId),
      onClick: () =>
        navigate(
          notificationDetails.path(location, tenantName, notificationId)
        ),
    },
  ],
  formFields: (formArgs) => {
    return {
      templateDetailsFields: [
        {
          key: 1,
          label: <FormattedMessage id="P_Name" />,
          name: "Name",
          placeholder: "Enter Notification Name",
          labelColor: "light",
          required: true,
          width: 25,
        },
        {
          key: 2,
          label: <FormattedMessage id="NOTIFICATION_MODE" />,
          name: "NotificationModeId",
          fieldName: "DisplayName",
          fieldValue: "Id",
          placeholder: "Select Notification Type",
          labelColor: "light",
          valueArr: formArgs.notificationModeList,
          type: "select",
          disabled: true,
          width: 25,
        },
        {
          key: 3,
          label: <FormattedMessage id="NOTIFICATION_TEMPLATE" />,
          name: "NotificationTemplateId",
          fieldName: "DisplayName",
          fieldValue: "Id",
          placeholder: "Select Notification Type",
          labelColor: "light",
          valueArr: formArgs.notificationTemplateList,
          type: "select",
          disabled: true,
          width: 25,
        },
        {
          key: 4,
          label: <FormattedMessage id="NOTIFICATION_TYPE" />,
          name: "NotificationTypeId",
          fieldName: "DisplayName",
          fieldValue: "Id",
          placeholder: "Select Notification Trigger Type",
          labelColor: "light",
          valueArr: formArgs.notificationTypeList,
          type: "select",
          disabled: true,
          width: 25,
        },
      ],
      generalSettingsFields: [
        {
          key: 1,
          label:
            formArgs?.formValues?.NotificationTypeId === 1
              ? <FormattedMessage id="EVENT_NAME" />
              : <FormattedMessage id="CN_OPTIONS" />,
          name: "EventTypeId",
          fieldName: "EventName",
          fieldValue: "Id",
          placeholder: "Select User or User Group",
          labelColor: "light",
          valueArr: formArgs.notificationEventList,
          type: "select",
          disabled: true,
          width: 25,
        },
        {
          key: 2,
          label:
            formArgs?.formValues?.NotificationTypeId === 1
              ? <FormattedMessage id="SELECT_EVENTS" />
              : <FormattedMessage id="TARGET_AUDIENCE" />,
          name: "EventValues",
          fieldName: "Value",
          fieldValue: "Key",
          type: "noSearchTags",
          tagType:
            formArgs?.formValues?.NotificationTypeId === 1 ? "single" : "multi",
          placeholder: "Enter Target Audience",
          searchTagsList: formArgs?.notificationEventValueList,
          labelColor: "light",
          required: true,
          isTagCheckBoxVisible:
            formArgs?.formValues?.NotificationTypeId === 1 ? false : true,
          width: 25,
          handleTagList: (tagsList) =>
            formArgs?.setNotificationEventValueList(tagsList),

          // valueArr: tagsList,
          //   searchTagsList: formArgs.searchTagsList,
          //   onChange: (e) => formArgs.handleSearchTags(e),
          //   loading: formArgs.getShotclassTagLoader,
          // handleTagList: (val) => setTagsList(val),
        },
        {
          key: 3,
          label: <FormattedMessage id="LANDING_PAGE" />,
          name: "LandingPageId",
          fieldName: "PageName",
          fieldValue: "Id",
          placeholder: "Select Landing Page",
          valueArr: [formArgs?.landingPageListItem],
          labelColor: "light",
          type: "select",
          width: 25,
        },
        {
          key: 4,
          label: <FormattedMessage id="LANDING_PREFERENCE" />,
          name: "LandingType",
          fieldName: "DisplayName",
          fieldValue: "DisplayName",
          placeholder: "Select Landing Preference",
          valueArr: [
            { Id: 1, DisplayName: "Event Value" },
            { Id: 2, DisplayName: "Content Value" },
          ],
          labelColor: "light",
          type: "select",
          width: 25,
        },
      ],
      notificationOccurrenceFields: [
        {
          key: 1,
          label: "Start Date and Time",
          name: "StartDateAndTime",
          labelColor: "light",
          type: "datetime-local",
          width: 25,
        },
        // {
        //   key: 2,
        //   label: "Hrs",
        //   name: "Hrs",
        //   labelColor: "light",
        //   type: "time",
        //   width: 7.6,
        // },
        // {
        //   key: 3,
        //   label: "Mins",
        //   name: "Mins",
        //   labelColor: "light",
        //   type: "time",
        //   width: 7.6,
        // },
        // {
        //   key: 4,
        //   label: "Period",
        //   name: "Period",
        //   fieldName: "DisplayName",
        //   fieldValue: "DisplayName",
        //   placeholder: "",
        //   valueArr: [
        //     { Id: 1, DisplayName: "Am" },
        //     { Id: 2, DisplayName: "Pm" },
        //   ],
        //   labelColor: "light",
        //   type: "select",
        //   width: 7.6,
        // },
        {
          key: 5,
          label: <FormattedMessage id="CN_TIMEZONES" />,
          name: "Timezones",
          fieldName: "Timezone",
          fieldValue: "Id",
          placeholder: "Select Period",
          valueArr: timeZones,
          labelColor: "light",
          type: "select",
          width: 25,
        },
        {
          key: 6,
          label: <FormattedMessage id="FREQUENCY_TXT" />,
          name: "FrequencyId",
          fieldName: "FrequencyName",
          fieldValue: "Id",
          placeholder: "Select Frequency",
          valueArr: formArgs.notificationFrequencyList,
          labelColor: "light",
          type: "select",
          disabled: true,
          width: 25,
        },
        {
          key: 7,
          label: <FormattedMessage id="RECURRING_IN" />,
          name: "RecurringInterval",
          placeholder: "Enter Recurring Interval",
          labelColor: "light",
          width: 25,
          disabled: true,
        },
        {
          key: 8,
          label: "Recurring Frequency",
          name: "RecurringFrequency",
          fieldName: "Value",
          fieldValue: "Id",
          placeholder: "Select Frequency",
          valueArr: [
            { Id: "Days", Value: "Days" },
            { Id: "Hours", Value: "Hours" },
          ],
          labelColor: "light",
          type: "select",
          disabled: true,
          width: 25,
        },
      ],
      messageTemplateFields: [
        {
          key: 1,
          label: <FormattedMessage id="PUSH_MESSAGE" />,
          name: "ShortMessage",
          labelColor: "light",
          labelMsg: "(Max : 42 Characters)",
          type: "textarea",
          placeholder: "Enter Notification Message",
          width: "100",
          widthType: "%",
          required: true,
        },
        {
          key: 2,
          label: "Message for Card/In-app Notification",
          name: "Message",
          labelColor: "light",
          labelMsg: "(Max : 96 Characters)",
          type: "textarea",
          placeholder: "Enter Card/In-App Notification Message",
          width: "100",
          widthType: "%",
          isHidden: formArgs?.formValues?.NotificationTypeId !== 2,
        },
        {
          key: 3,
          name: "PlaceHolderList",
          label: "Add Placeholder in message",
          labelColor: "light",
          type: "noSearchTags",
          fieldName: "PlaceHolderName",
          fieldValue: "Id",
          placeholder: "Select",
          height: "5",
          width: "25",
          searchTagsList: formArgs?.notificationPlaceHolderList,
          handleClickTag: (tag) => formArgs?.handleClickPlaceHolderTag(tag),
          addedTagsVisible: false,
          isTagCheckBoxVisible: false,
          disabled: false,
          isHidden: formArgs?.formValues?.NotificationTypeId !== 2,
        },
      ],
    };
  },
  formData: {
    Id: null,
    Name: "",
    EventTypeId: null,
    EventValue: "",
    EventValues: [],
    EventValueId: null,
    PlaceHolderEventId: 0,
    PlaceHolderEventValue: null,
    PlaceHolderEventValueId: null,
    FrequencyId: 1,
    NotificationTemplateId: 1,
    NotificationTemplate: "",
    NotificationTemplateDisplayName: "",
    NotificationTypeId: 3,
    NotificationType: "",
    NotificationTypeDisplayName: "",
    NotificationModeId: 1,
    NotificationMode: "",
    NotificationDisplayName: "",
    CardNotificationTemplateId: 0,
    CardNotificationTemplate: "",
    CardNotificationTemplateDisplayName: "",
    NotifyIn: null,
    RecurringIn: null,
    ShortMessage: "",
    Message: "",
    PlaceHolderMapping: [],
    LandingPageId: 1,
    IsActive: true,
    CreatedOn: "",
    FormattedNotifyIn: "",
    RecurringInterval: 1,
    RecurringFrequency: "",
    IsEventBase: true,
    LandingType: "",
    TrainingTypeMapping: [],
    ModifiedOn: "",
  },
};
